export default () => ({
  type: "DRAGGING/BEGIN"
});
